import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import LumientLogoMark from "@/components/LumientLogoMark";
import SEOHead from "@/components/SEOHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#0B0B0B] flex flex-col items-center justify-center px-6 text-center relative overflow-hidden">
      <SEOHead title="Page Not Found — Lumient" description="The page you're looking for doesn't exist." noindex />
      {/* Background logo watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
        <img
          src="/brand/lumient-logo-mark.svg"
          className="w-[480px] h-[480px]"
          alt=""
          style={{ opacity: 0.04, filter: "brightness(0) invert(1)" }}
        />
      </div>

      <div className="relative space-y-8">
        <div className="flex items-center justify-center gap-3">
          <LumientLogoMark />
          <span className="text-white font-medium text-sm tracking-wide">Lumient</span>
        </div>

        <div className="space-y-3">
          <p className="text-sm font-medium tracking-[0.2em] uppercase" style={{ color: "#C8900A" }}>
            404
          </p>
          <h1 className="text-4xl lg:text-5xl font-serif text-white leading-tight">
            Page not found.
          </h1>
          <p className="text-sm font-light max-w-sm mx-auto" style={{ color: "rgba(255,255,255,0.5)" }}>
            This page doesn't exist or may have moved. Head back to the homepage.
          </p>
        </div>

        <a
          href="/"
          className="inline-block glow-button bg-primary text-white px-8 py-3 rounded-full text-sm font-semibold tracking-wide transition-all duration-300"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
